import { Box, Typography, Radio } from "@mui/material";
import { getImageURL } from "./relationImageUtils";
  
const BeneficiaryCard = ({ beneficiary, selected, onSelect }) => {
  const imageURL = getImageURL(beneficiary.relationName, beneficiary.gender);

  return (
    <Box
      onClick={() => onSelect(beneficiary)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "16px",
        borderRadius: "12px",
        border: selected ? "1.5px solid #0066DC" : "1px solid #d2d8e0",
        backgroundColor: "#fff",
        cursor: "pointer",
        position: "relative",
        minWidth: { xs: "280px", md: "auto" },
      }}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect(beneficiary);
        }
      }}
    >
      <Box
        component="img"
        src={imageURL}
        alt={beneficiary.name}
        sx={{
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          objectFit: "cover",
          flexShrink: 0,
        }}
        onError={(e) => {
          e.target.src = `https://views.medibuddy.in/mb-web/public/${
            beneficiary.gender === "M" ? "male.svg" : "female.svg"
          }`;
        }}
      />

      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "#252D38",
            lineHeight: "22px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {beneficiary.name}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 300,
            color: "#47566A",
            lineHeight: "20px",
          }}
        >
          {beneficiary.relationName}
        </Typography>
      </Box>

      <Radio
        checked={selected}
        sx={{
          color: "#252D38",
          "&.Mui-checked": {
            color: "#0066DC",
          },
          padding: "8px",
        }}
      />
    </Box>
  );
};

export default BeneficiaryCard;